import debounce from 'lodash-es/debounce';

/**
 * Класс раскрывающегося списка с акциями
 * @example
 *
 * Классы:
 * .badge-collapse.show - открыть список с акциями
 * .badge-collapse_overflowing - список больше одной строки, показ кнопки
 *
 * Переменные:
 * --max-height: максимальная высота при скрытом виде (одна строка)
 */
class BadgeCollapse {
  /***
   * Конструктор класса
   * @param elem {HTMLElement} DOM элемент формы с классом badge-collapse
   */
  constructor(elem) {
    if (!elem) return
    this.block = elem;
    this.block.BadgeCollapse = this;

    this.init();
  }

  init = () => {
		this.button = this.block.querySelector('.badge-collapse__button');
		if (!this.button) return console.error('BadgeCollapse: отсутствует .badge-collapse__button');

		this.list = this.block.querySelector('.badge-collapse__list');
		if (!this.list) return console.error('BadgeCollapse: отсутствует .badge-collapse__list');

		this.toggleButton();

		this.button.addEventListener('click', this.toggleCollapse);
		window.addEventListener('resize', this.resize);

    this.block.classList.add('badge-collapse_inited');
  };

	resize = debounce(() => {
		this.toggleButton();
	}, 500);

	toggleButton = () => {
		const toggle = this.list.offsetHeight > parseInt(window.getComputedStyle(this.block).getPropertyValue('--max-height'), 10)
		this.block.classList.toggle('badge-collapse_overflowing', toggle)
	}

	toggleCollapse = () => this.block.classList.toggle('show');

  destroy = () => {
		window.removeEventListener('resize', this.resize);
		if (this.button) this.button.removeEventListener('click', this.toggleCollapse);
    if (this.block) {
      this.block.classList.remove('badge-collapse_inited');
      delete this.block.BadgeCollapse;
    }
  };

  static init() {
    Array.from(document.querySelectorAll('.badge-collapse:not(.badge-collapse_inited)')).forEach((elem) => new BadgeCollapse(elem));
  }
}

document.addEventListener('DOMContentLoaded', BadgeCollapse.init);

// Экспорт;
window.Block = window.Block ? window.Block : {};
window.Block.BadgeCollapse = BadgeCollapse;
